// @flow
// Libs
import React, { Component } from 'react'
import _isNumber from 'lodash/isNumber'
import _round from 'lodash/round'
import { FormattedMessage } from 'react-intl'

// Utils
import traverse from 'fc-utils/traverse'

// messages
import { messages } from 'hfty-comments'

// Image
import logo2 from 'hfty-images/src/FE_Soils_Logo.png'

const styles = {
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  headerImage: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  commentText: {
    textAlign: 'center',
    marginTop: 10,
    fontSize: 30,
  },
  image: {
    width: 300,
  },
  grayBackground: {
    backgroundColor: 'lightGray',
  },
  customerInfo: {
    margin: 5,
  },
  customerInfoGray: {
    backgroundColor: 'lightGray',
    padding: 5,
  },
  spacer: {
    margin: '3px 0',
  },
  headerBox: {
    border: '1px solid black',
    padding: 10,
    marginLeft: 30,
    marginTop: 20,
    width: 310,
    lineHeight: 1.3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  boxParagraph: {
    marginBottom: 15,
  },
  customerInfoDiv: {
    marginLeft: 20,
  },
  title: {
    fontWeight: 500,
    marginRight: 5,
  },
}
type Props = {
  data: Object,
  cropUnit: string,
}
export default class Header extends Component {
  props: Props
  render(): React.Element<any> {
    const { cropUnit, data } = this.props
    const yield_goal = traverse(['yield_goal'], { default: '--' })(data)
    return (
      <div style={styles.header}>
        <div style={styles.headerImage}>
          <img style={styles.image} src={logo2} />
          <label style={styles.commentText}>
            <FormattedMessage {...messages['comments']} />
          </label>
        </div>
        <div style={styles.customerInfoDiv}>
          <div style={styles.customerInfo}>
            <span>
              <label style={styles.title}>
                <FormattedMessage {...messages['customer']} />:
              </label>
              <label>{traverse(['customer'], { default: '--' })(data)}</label>
            </span>
          </div>
          <div style={styles.customerInfo}>
            <span>
              <label style={styles.title}>
                <FormattedMessage {...messages['recordDate']} />:
              </label>
              <label>{traverse(['record_date'], { default: '--' })(data)}</label>
            </span>
          </div>
          <div style={styles.customerInfo}>
            <span>
              <label style={styles.title}>
                <FormattedMessage {...messages['samples']} />:
              </label>
              <label>{traverse(['num_samples'], { default: '--' })(data)}</label>
            </span>
          </div>
          <div style={styles.customerInfo}>
            <span>
              <label style={styles.title}>Farm:</label>
              <label>{traverse(['farm'], { default: '--' })(data)}</label>
            </span>
          </div>
          <div style={styles.customerInfo}>
            <span>
              <label style={styles.title}>
                <FormattedMessage {...messages['field']} />:
              </label>
              <label>{traverse(['field'], { default: '--' })(data)}</label>
            </span>
          </div>
          <div style={styles.spacer} />
          <div style={styles.customerInfoGray}>
            <span>
              <label style={styles.title}>
                <FormattedMessage {...messages['crop']} />:
              </label>
              <label>{traverse(['crop'], { default: '--' })(data)}</label>
            </span>
          </div>
          <div style={styles.customerInfoGray}>
            <span>
              <label style={styles.title}>
                <FormattedMessage {...messages['targetYield']} />:
              </label>
              <span style={{ marginRight: 5 }}>{_isNumber(yield_goal) ? _round(yield_goal, 2) : yield_goal}</span>
              <FormattedMessage {...messages[`${cropUnit}`]} />
            </span>
          </div>
        </div>
        <div style={styles.headerBox}>
          <p style={styles.boxParagraph}>
            <FormattedMessage {...messages['headerText1']} />
          </p>
          <p style={styles.boxParagraph}>
            <FormattedMessage {...messages['headerText2']} />
          </p>
          <p style={styles.boxParagraph}>
            <FormattedMessage {...messages['headerText3']} />
          </p>
        </div>
      </div>
    )
  }
}
